export const firebaseConfig = {
    apiKey: "AIzaSyBtvfZ2iws-K5d7whSGxoEuDc6Db-8zMCU",
    authDomain: "cm-stella.firebaseapp.com",
    projectId: "cm-stella",
    storageBucket: "cm-stella.appspot.com",
    messagingSenderId: "1091734572733",
    appId: "1:1091734572733:web:b781e2edb13fedfddcb1d4"
};
